









































import { Component, mixins, Prop, Vue } from 'nuxt-property-decorator'
import Vue2TouchEvents from 'vue2-touch-events'
import { IImageVariants } from '~/assets/interfaces/images'
import MixinGeneral from '~/assets/mixins/general'
import ComponentImage from '~/components/images/image.vue'

// Плагин touch-events подключён с ssr: false, а директива нужна и при
// серверном рендере — регистрируем здесь, один раз для всех карточек.
Vue.use(Vue2TouchEvents)

// Фото в карточке товара: ссылка на товар, переключение по наведению и
// свайпу, точки текущего фото, серая подложка по опции с бэка. Один
// компонент для всех вариантов карточки.
@Component({
  components: {
    ComponentImage,
  },
})
export default class ComponentProductCardImage extends mixins(MixinGeneral) {
  @Prop({ type: Array, default: () => [] }) readonly images!: IImageVariants[]
  @Prop({ type: Number, default: 0 }) readonly imageNumber!: number
  @Prop({ type: String, default: '' }) readonly url!: string
  @Prop({ type: String, default: null }) readonly alt!: string | null
  @Prop({ type: String, default: null }) readonly title!: string | null
  @Prop({ type: Boolean, default: false }) readonly backdrop!: boolean
  // Распорка под соотношение сторон и размытое превью — считает карточка
  // (MixinProductCard.styleImage).
  @Prop({ type: Object, default: () => ({}) })
  readonly imageStyle!: Record<string, string>

  private onSwipe(direction: string) {
    this.$emit('swipe', direction)
  }
}
